module.exports = __webpack_public_path__ + "img/nt55-05-80-1-asm.prt.cfc252a3.jpg";